import { appEnvironment } from 'configs'

/**
 * @param {*} activeStoragePlan - Photographer's active storage plan
 * @returns Gallery storage plan limit in gigabytes
 */
export const getGalleryStorageLimit = (activeStoragePlan, activeSubscription) => {
  if (!activeStoragePlan && !activeSubscription) return 10

  let storageLimit = 0

  //Gallery Storage Plan Limits
  if (activeStoragePlan && activeStoragePlan.stripeProduct.name === '5TB Storage Plan') storageLimit += 5000
  if (activeStoragePlan && activeStoragePlan.stripeProduct.name === '100GB Storage Plan') storageLimit += 100

  //Focal Subscription Plan Limits
  if (
    activeSubscription &&
    activeSubscription.stripeProduct.name.includes('All You Need') |
      activeSubscription.stripeProduct.name.includes('Pro Plan')
  )
    storageLimit += 5000
  else if (activeSubscription) storageLimit += 100

  return storageLimit
}

export function isLegacyUser(context) {
  if ((context && context.photographer?.isCreatorOnly) || (context && context.photographer?.activeWebsite)) {
    return false
  }
  return true
}

export const toTitleCase = (string) => {
  let words = string.trim().split(' ')
  for (let word in words) {
    words[word] = words[word][0].toUpperCase() + words[word].substring(1)
  }
  return words.join(' ')
}

export function statuses(val) {
  if (val === 0) {
    return 'Draft'
  } else if (val === 1) {
    return 'On Portfolio'
  } else if (val === 2) {
    return 'Hidden'
  }
}

export function statusColorClass(val) {
  if (val === 0) {
    return 'text-danger'
  } else if (val === 1) {
    return 'text-success'
  } else if (val === 2) {
    return 'text-warning'
  }
}

export function statusTooltipText(val) {
  if (val === 0) {
    return 'This package is being drafted and does not appear publicly'
  } else if (val === 1) {
    return "This Package is Published to it's associated category portfolio and is available to view publicly on your portfolio and the Focal marketplace (if applicable)."
  } else if (val === 2) {
    return 'This package is hidden from your portfolio but can still be accessed privately via direct link'
  }
}

export const packageCategories =
  appEnvironment === 'production'
    ? {
        1: { name: 'All', priority: 14 },
        2: { name: 'Featured', priority: 1 },
        3: { name: 'Headshots', priority: 5 },
        4: { name: 'Family', priority: 3 },
        5: { name: 'Newborn & Maternity', priority: 4 },
        6: { name: 'Wedding & Engagement', priority: 2 },
        7: { name: 'Portrait', priority: 6 },
        8: { name: 'Corporate Events', priority: 10 },
        9: { name: 'Boudoir', priority: 12 },
        10: { name: 'Product', priority: 11 },
        11: { name: 'Architecture & Real Estate', priority: 13 },

        13: { name: 'Events', priority: 8 },
        14: { name: 'Branding', priority: 7 },
      }
    : {
        1: { name: 'All', priority: 14 },
        2: { name: 'Featured', priority: 1 },
        3: { name: 'Headshots', priority: 5 },
        4: { name: 'Family', priority: 3 },
        5: { name: 'Newborn & Maternity', priority: 4 },
        6: { name: 'Wedding & Engagement', priority: 2 },
        7: { name: 'Portrait', priority: 6 },
        8: { name: 'Corporate Events', priority: 10 },
        9: { name: 'Boudoir', priority: 12 },
        10: { name: 'Product', priority: 11 },
        11: { name: 'Architecture & Real Estate', priority: 13 },
        12: { name: 'Events', priority: 7 },

        14: { name: 'Branding', priority: 8 },
      }

export const singularPackageCategories =
  appEnvironment === 'production'
    ? {
        1: { name: 'All', priority: 14 },
        2: { name: 'Featured', priority: 1 },
        3: { name: 'Headshot', priority: 5 },
        4: { name: 'Family', priority: 3 },
        5: { name: 'Newborn & Maternity', priority: 4 },
        6: { name: 'Wedding & Engagement', priority: 2 },
        7: { name: 'Portrait', priority: 6 },
        8: { name: 'Corporate Event', priority: 10 },
        9: { name: 'Boudoir', priority: 12 },
        10: { name: 'Product', priority: 11 },
        11: { name: 'Architecture & Real Estate', priority: 13 },

        13: { name: 'Event', priority: 8 },
        14: { name: 'Branding', priority: 7 },
      }
    : {
        1: { name: 'All', priority: 14 },
        2: { name: 'Featured', priority: 1 },
        3: { name: 'Headshot', priority: 5 },
        4: { name: 'Family', priority: 3 },
        5: { name: 'Newborn & Maternity', priority: 4 },
        6: { name: 'Wedding & Engagement', priority: 2 },
        7: { name: 'Portrait', priority: 6 },
        8: { name: 'Corporate Event', priority: 10 },
        9: { name: 'Boudoir', priority: 12 },
        10: { name: 'Product', priority: 11 },
        11: { name: 'Architecture & Real Estate', priority: 13 },
        12: { name: 'Event', priority: 7 },

        14: { name: 'Branding', priority: 8 },
      }

export const packageCategoriesForUrl =
  appEnvironment === 'production'
    ? {
        1: { name: 'all', priority: 14 },
        2: { name: 'featured', priority: 1 },
        3: { name: 'headshots', priority: 5 },
        4: { name: 'family', priority: 3 },
        5: { name: 'newborn-&-maternity', priority: 4 },
        6: { name: 'wedding-&-engagement', priority: 2 },
        7: { name: 'portrait', priority: 6 },
        8: { name: 'corporate Events', priority: 10 },
        9: { name: 'boudoir', priority: 12 },
        10: { name: 'product', priority: 11 },
        11: { name: 'architecture-&-real-estate', priority: 13 },

        13: { name: 'events', priority: 8 },
        14: { name: 'branding', priority: 7 },
      }
    : {
        1: { name: 'all', priority: 14 },
        2: { name: 'featured', priority: 1 },
        3: { name: 'headshots', priority: 5 },
        4: { name: 'family', priority: 3 },
        5: { name: 'newborn-&-maternity', priority: 4 },
        6: { name: 'wedding-&-engagement', priority: 2 },
        7: { name: 'portrait', priority: 6 },
        8: { name: 'corporate-events', priority: 10 },
        9: { name: 'boudoir', priority: 12 },
        10: { name: 'product', priority: 11 },
        11: { name: 'architecture-&-real-estate', priority: 13 },
        12: { name: 'events', priority: 7 },

        14: { name: 'branding', priority: 8 },
      }

export const lengthConstraints = {
  description: 1500,
  whatToExpect: 1500,
  cancellationPolicy: 1000,
  extensionPolicy: 1000,
  licensePolicy: 1000,
  weatherPolicy: 1000,
  paymentSchedulePolicy: 1000,
  addOnsPolicy: 1000,
  answer: 1000,
  question: 128,
  bio: 1500,
}

export const LINK_BASE =
  appEnvironment === 'production'
    ? `https://app.bookfocal.com`
    : appEnvironment === 'development'
    ? `https://app.dev.bookfocal.com`
    : //`http://192.168.1.107:3000`
      `http://localhost:3000`

export const PUBLIC_LINK_BASE = (photographer) => {
  return appEnvironment === 'production'
    ? photographer.domain
      ? `https://${photographer.domain}`
      : `https://app.bookfocal.com`
    : appEnvironment === 'development'
    ? photographer.domain
      ? `https://${photographer.domain}`
      : `https://app.dev.bookfocal.com`
    : // `http://192.168.1.107:3000`
      `http://localhost:3000`
}

export const ADMIN_LINK_BASE = (photographer) => {
  return appEnvironment === 'production'
    ? `https://app.bookfocal.com`
    : appEnvironment === 'development'
    ? `https://app.dev.bookfocal.com`
    : `http://localhost:3000`
}

export const GST = 0.05

export const PASSWORD_LENGTH = 8

export const MESSAGES_EMAIL = 'contact@bookfocal.com'

export const policies = {
  extensionPolicy: `Shoot may be extended with mutual consent. The possibility of an extended shoot should be discussed beforehand. The hourly package rate will apply.
  Reshoots can be arranged at a cost of 50% of the hourly package rate.`,
  paymentSchedulePolicy: `50% deposit at the time of booking, 50% remainder due 3 days after the photoshoot. Payments may be made by credit card upon receiving an invoice.`,
  cancellationPolicy: `7 days before the shoot date & time: 100% refund
  Between 7 days and 24 hours before the shoot date & time: 50% refund
  Less than 24 hours before the shoot date & time: no refund
  Booking is considered cancelled when the client messages the photographer in writing`,
  licensePolicy: `Photographer retains copyright over the Photographic Work and is able to use it for self-promotion. The client may make unlimited reproductions of the Photographic Work for family and friends both online and offline.`,
  weatherPolicy: `Photoshoots will typically take place rain or shine. For outdoor shoots, an agreed alternate location may be planned in advance.
  Shoots will only be cancelled and a full refund given in the most extreme circumstances. If the shoot can be rescheduled  there will be no additional fees for the customer.`,
  licenseType: 0,
  paymentSchedule: 1,
  paymentPolicyUpFront: `Payment in full at the time of booking. Payments may be made by credit card upon receiving an invoice.`,
  paymentPolicyHalf: `50% deposit at the time of booking, 50% remainder due 3 days after the photoshoot. Payments may be made by credit card upon receiving an invoice.`,
  licensePersonal:
    'Photographer retains copyright over the Photographic Work and is able to use it for self-promotion. The client may make unlimited reproductions of the Photographic Work for family and friends both online and offline.',
  licenseCommercial:
    'Commercial Use Licence: same as the Personal Use Licence plus permission for the client to use the Photographic Work to promote their business.',
}

export const FOCAL_PHOTO_RIGHTS_POLICY = `Focal is granted the right to use any photos for self-promotion. Credit will be given to the photographer. If you do not want your images used in this manner please let your photographer know during the booking process and we will honour your request.`

export const urlCategories =
  appEnvironment === 'production'
    ? {
        1: { name: 'all', priority: 14 },
        2: { name: 'featured', priority: 1 },
        3: { name: 'headshots', priority: 5 },
        4: { name: 'family', priority: 3 },
        5: { name: 'newborn-and-maternity', priority: 4 },
        6: { name: 'wedding-and-engagement', priority: 2 },
        7: { name: 'portrait', priority: 6 },
        8: { name: 'corporate-events', priority: 10 },
        9: { name: 'boudoir', priority: 12 },
        10: { name: 'product', priority: 11 },
        11: { name: 'architecture-and-real-estate', priority: 13 },

        13: { name: 'events', priority: 8 },
        14: { name: 'branding', priority: 7 },
      }
    : {
        1: { name: 'all', priority: 14 },
        2: { name: 'featured', priority: 1 },
        3: { name: 'headshots', priority: 5 },
        4: { name: 'family', priority: 3 },
        5: { name: 'newborn-and-maternity', priority: 4 },
        6: { name: 'wedding-and-engagement', priority: 2 },
        7: { name: 'portrait', priority: 6 },
        8: { name: 'corporate-events', priority: 10 },
        9: { name: 'boudoir', priority: 12 },
        10: { name: 'product', priority: 11 },
        11: { name: 'architecture-and-real-estate', priority: 13 },
        12: { name: 'events', priority: 7 },

        14: { name: 'branding', priority: 8 },
      }

export const urlCategoriesWithAnd =
  appEnvironment === 'production'
    ? {
        1: { name: 'all', priority: 14 },
        2: { name: 'featured', priority: 1 },
        3: { name: 'headshots', priority: 5 },
        4: { name: 'family', priority: 3 },
        5: { name: 'newborn-&-maternity', priority: 4 },
        6: { name: 'wedding-&-engagement', priority: 2 },
        7: { name: 'portrait', priority: 6 },
        8: { name: 'corporate-events', priority: 10 },
        9: { name: 'boudoir', priority: 12 },
        10: { name: 'product', priority: 11 },
        11: { name: 'architecture-&-real-estate', priority: 13 },

        13: { name: 'events', priority: 8 },
        14: { name: 'branding', priority: 7 },
      }
    : {
        1: { name: 'all', priority: 14 },
        2: { name: 'featured', priority: 1 },
        3: { name: 'headshots', priority: 5 },
        4: { name: 'family', priority: 3 },
        5: { name: 'newborn-&-maternity', priority: 4 },
        6: { name: 'wedding-&-engagement', priority: 2 },
        7: { name: 'portrait', priority: 6 },
        8: { name: 'corporate-events', priority: 10 },
        9: { name: 'boudoir', priority: 12 },
        10: { name: 'product', priority: 11 },
        11: { name: 'architecture-&-real-estate', priority: 13 },
        12: { name: 'events', priority: 7 },

        14: { name: 'branding', priority: 8 },
      }

export const questionnaireTemplate = `
<p><span style="color: rgb(0, 0, 0);">Thank you for choosing me as your wedding photographer! I am thrilled to be a part of your special day and to capture the beautiful moments that will last a lifetime. In order to ensure that I provide you with the best possible experience, I kindly request that you complete the questionnaire below. Your answers will help me better understand your preferences, expectations, and the details of your wedding day.</span></p><p><span style="color: rgb(0, 0, 0);">Please feel free to provide as much information as you'd like, and don't hesitate to reach out if you have any questions.</span></p><p><span style="color: rgb(0, 0, 0);">Partner's Full Name: </span><span style="color: rgb(204, 102, 102);">____________________________________________________________________</span></p><p><span style="color: rgb(0, 0, 0);">Partner's Full Name: </span><span style="color: rgb(204, 102, 102);">____________________________________________________________________</span></p><p><span style="color: rgb(0, 0, 0);">Wedding Date: </span><span style="color: rgb(204, 102, 102);">____________________________________________________________________</span></p><p><span style="color: rgb(0, 0, 0);">Ceremony Start Time: </span><span style="color: rgb(204, 102, 102);">____________________________________________________________________</span></p><p><span style="color: rgb(0, 0, 0);">Ceremony Venue Name and Address: </span><span style="color: rgb(204, 102, 102);">____________________________________________________________________</span></p><p><span style="color: rgb(0, 0, 0);">Reception Venue Name and Address (if different from ceremony): </span><span style="color: rgb(204, 102, 102);">____________________________________________________________________</span></p><p><span style="color: rgb(0, 0, 0);">Is there a specific theme or style for your wedding? (e.g., rustic, vintage, modern, traditional, etc.): </span><span style="color: rgb(204, 102, 102);">____________________________________________________________________</span></p><p><span style="color: rgb(0, 0, 0);">Please provide a brief timeline of the day's events (including the time of the first look, ceremony, cocktail hour, reception, cake cutting, etc.): </span></p><p><span style="color: rgb(204, 102, 102);">/8____________________________________________________________________8/</span></p><p><span style="color: rgb(0, 0, 0);">Are there any special traditions or events during the ceremony or reception that you would like us to capture? (e.g., unity candle, sand ceremony, cultural dances, etc.): </span></p><p><span style="color: rgb(204, 102, 102);">/8____________________________________________________________________8/</span></p><p><span style="color: rgb(0, 0, 0);">Are there any specific shots or moments you would like us to focus on? (e.g., bridal party getting ready, first look, first dance, etc.): </span></p><p><span style="color: rgb(204, 102, 102);">/8____________________________________________________________________8/</span></p><p><span style="color: rgb(0, 0, 0);">Are there any special requests or concerns you would like us to be aware of? </span></p><p><span style="color: rgb(204, 102, 102);">/8____________________________________________________________________8/</span></p><p><span style="color: rgb(0, 0, 0);">Is there any additional information you would like to share with us? </span></p><p><span style="color: rgb(204, 102, 102);">/8____________________________________________________________________8/</span></p><p><span style="color: rgb(0, 0, 0);">Please return the completed questionnaire to us at your earliest convenience. Once again, thank you for choosing us as your wedding photographers. We are looking forward to creating lasting memories for you and your loved ones.</span></p>`

export const contractTemplate = `
<p><span style="color: rgb(0, 0, 0);">This photography contract, is between </span><span style="color: rgb(237, 123, 123);">{NAME To Be Filled by Photographer}</span><span style="color: rgb(0, 0, 0);">, hereafter referred to as “Photographer”, and </span><span style="color: rgb(237, 123, 123);">the undersigned</span><span style="color: rgb(0, 0, 0);">, hereafter referred to as “Client”.</span></p><p><br></p><p><span style="color: rgb(0, 0, 0);">Client’s Names: </span><span style="color: rgb(237, 123, 123);">__________________________________</span></p><p><span style="color: rgb(0, 0, 0);">Client’s Address: </span><span style="color: rgb(237, 123, 123);">__________________________________</span></p><p><span style="color: rgb(0, 0, 0);">Client’s Phone: </span><span style="color: rgb(237, 123, 123);">________________________</span><span style="color: rgb(0, 0, 0);">&nbsp;&nbsp;&nbsp;&nbsp;</span></p><p><span style="color: rgb(0, 0, 0);">Client’s Email: </span><span style="color: rgb(237, 123, 123);">________________________</span></p><p><br></p><p><span style="color: rgb(127, 127, 127);">QUESTIONNAIRE</span><span style="color: rgb(237, 123, 123);">&nbsp;</span></p><p><br></p><p><span style="color: rgb(25, 25, 25);">Est. Number of People: </span><span style="color: rgb(237, 123, 123);">________________________</span></p><p><span style="color: rgb(25, 25, 25);">Event Location: </span><span style="color: rgb(237, 123, 123);">________________________</span></p><p><br></p><p><span style="color: rgb(0, 0, 0);">In consideration of this arrangement between the parties and the fees to be paid as per outlined below, and for other good and valuable consideration, the parties now agree as follows:</span></p><p><br></p><p><span style="color: rgb(127, 127, 127);">DESCRIPTION OF SERVICES</span></p><p><br></p><p><span style="color: rgb(0, 0, 0);">Photographer’s artistic coverage in hours along with other deliverables are defined under the “What’s Included” section of the Package listed on the Booking Page. Please review the details carefully on the ‘Order Summary’ section of the Booking page where this contact is signed. By signing you accept the terms of the Package’s deliverables, policies and conditions.</span></p><p><br></p><p><span style="color: rgb(0, 0, 0);">The Photographer does NOT guarantee long-term archival of the digital files and will not be held responsible if loss occurs </span><span style="color: rgb(237, 123, 123);">1 </span><span style="color: rgb(0, 0, 0);">year after the event/session.</span></p><p><br></p><p><span style="color: rgb(127, 127, 127);">RETAINER AND PAYMENT</span></p><p><br></p><p><span style="color: rgb(0, 0, 0);">Upon signature, the Photographer reserves the time and date agreed upon, and will not make other reservations for that time and date. For this reason, the Client shall make a retainer payment to book the date with Photographer. This retainer payment is non-refundable, even if the date is changed or the event is canceled for any reason, including acts of god, fire, pandemic-related restrictions, and extreme weather. The retainer fee is to be paid at the time of parties signing this contract and is applied towards the photography package balance upon completion of this contract.</span></p><p><br></p><p><span style="color: rgb(0, 0, 0);">The Client(s) understand and agree that the remaining balance owed for the photography package described in this contract, if it has not already been fully paid by the retainer fee, is due on the date of the event. The Client(s) agree to pay the Photographer using the Focal Booking Page unless otherwise agreed upon in writing.</span></p><p><br></p><p><span style="color: rgb(127, 127, 127);">CANCELLATION</span></p><p><br></p><p><span style="color: rgb(0, 0, 0);">If the Client should cancel the event/session for any reason with at least </span><span style="color: rgb(237, 123, 123);">30 days</span><span style="color: rgb(0, 0, 0);"> notice provided, the Photographer agrees to refund all money paid, </span><span style="color: rgb(237, 123, 123);">excluding</span><span style="color: rgb(0, 0, 0);"> the retainer fee. If canceling this Contract, the Client must notify the Photographer in writing by email. To consider a date change, the Photographer must first receive a written release of the current contracted date, which will null and void this written contract. If the Client needs to change the event date, all money paid will transfer to the new date per a newly written and signed contract IF that date is available for the Photographer. The new date must be within six months of the original agreed-upon date, or the new contract will be subject to the Photographer's current rates, if they have changed. If the new date is unavailable with the Photographer, the Contract will be cancelled and the retainer </span><span style="color: rgb(234, 153, 153);">will not</span><span style="color: rgb(0, 0, 0);"> be refunded.</span></p><p><br></p><p><span style="color: rgb(127, 127, 127);">LIMITATION OF SERVICES</span></p><p><br></p><p><span style="color: rgb(0, 0, 0);">A meal is required for the Photographer for events 6 hours or longer. If no meal is provided, it is understood that the Photographer will require a break to leave the event/session at some point to purchase a meal.</span></p><p><br></p><p><span style="color: rgb(0, 0, 0);">This Contract is not to be construed as an employment agreement in any way. The Photographer functions as an Independent Contractor.</span></p><p><br></p><p><span style="color: rgb(127, 127, 127);">LIABILITY OF PHOTOGRAPHER</span></p><p><br></p><p><span style="color: rgb(0, 0, 0);">Although the utmost care will be taken, the Photographer may be unable to deliver the photos due to unforeseen circumstances such as fire, casualty, act of god, illness, or any other cause beyond the control of the Photographer. In this case, the Photographer shall return all money paid and have no further liability with respect to this contract. This limitation of liability shall also apply in the event that photographic materials are damaged in processing, lost through camera or memory card malfunction, or otherwise lost or damaged without fault on the part of the Photographer. In the event that the Photographer fails to perform for any other reason, the Photographer shall not be liable for any amount in excess of the value of the Client's contract price stated herein.</span></p><p><br></p><p><span style="color: rgb(127, 127, 127);">ARTISTIC LICENSE</span></p><p><br></p><p><span style="color: rgb(0, 0, 0);">The Photographer shall be granted artistic license in relation to the poses photographed and the locations used. The Photographer’s judgment regarding the location, poses and number of photographs taken shall be deemed correct.</span></p><p><br></p><p><span style="color: rgb(0, 0, 0);">Photographs taken during the course of the event/session will be at the discretion of the Photographer, although every effort will be made to comply with the Client’s requirements and vision. If more than one subject is involved in the event/session, the Photographer shall endeavor to photograph all individuals as requested by the Client at some point, but no responsibility will be taken by the Photographer on the occasion of leaving somebody out. The Photographer shall also endeavor to capture all the moments throughout the event/session as they occur. However, because of the fluid nature of events/sessions, some moments might not be recorded, or not recorded for logistical reasons.</span></p><p><br></p><p><span style="color: rgb(127, 127, 127);">VENUES, FAMILY/FRIENDS, AND PHOTOGRAPHER RESTRICTIONS</span></p><p><br></p><p><span style="color: rgb(0, 0, 0);">For a booking involving a church ceremony or at certain venues, the official in charge sometimes restricts the Photographer’s movements. The area from which the Photographer is able to cover the event/ceremony may not be the Photographer’s choice and the Photographer cannot accept responsibility for any obstructed view should this be the case. The use of artificial lighting may be restricted or prohibited. The photographing of parts or even all of the event/ceremony may be restricted or prohibited. The Client(s) are strongly advised to check with the appropriate official(s) before booking the date and submitting this contract.</span></p><p><br></p><p><span style="color: rgb(0, 0, 0);">If the Client is hiring the Photographer for a wedding/elopement, family and friends will be permitted to photograph at the wedding as long as they do not interfere with the Photographer’s duties and do not photograph poses arranged by the Photographers, due to reasons of the Photographer delivering the quality of images as expected.</span></p><p><br></p><p><span style="color: rgb(127, 127, 127);">EXCLUSIVITY</span></p><p><br></p><p><span style="color: rgb(0, 0, 0);">Photographer is hereby retained as the sole and exclusive professional photographer to perform photographic services contained herein. The Client shall take any necessary action to ensure that the Photographer is not hindered nor harmed in performing services for the Client. Any breach of this agreement can constitute a reason for non-completion of the job with no liability to the Photographer.</span></p><p><br></p><p><span style="color: rgb(127, 127, 127);">TERMS AND CONDITIONS</span></p><p><br></p><p><span style="color: rgb(0, 0, 0);">The Copyright Law assigns the copyright of the images to the Photographer, and all images shall remain the sole property of Photographer. The Photographer retains for life the right to display any photograph covered by this Contract and to generally promote the business in advertising, brochures, magazine articles, websites, sample albums and prints, venue and other vendor samples, and other such material, providing that the images used are used lawfully and without damage to the Client.</span></p><p><br></p><p><span style="color: rgb(0, 0, 0);">The Photographer hereby grants to the Client, a limited, non-exclusive, non-transferable, royalty-free license to reproduce, display and/or distribute the images, provided the Client complies with the condition that all such reproductions and/or displays are not intended for a commercial venture.</span></p><p><br></p><p><span style="color: rgb(0, 0, 0);">Although all equipment is checked regularly and reasonable steps are taken to ensure backup equipment is available, the Photographer will not be responsible for photographs that are not produced due to technical failure, either at the shooting or processing stage. </span><span style="color: rgb(102, 73, 58);">&nbsp;</span></p><p><br></p><p><span style="color: rgb(127, 127, 127);">TERMS AND CONDITIONS (CONT’D)</span></p><p><br></p><p><span style="color: rgb(0, 0, 0);">Due to a variety of lighting conditions and the limitations of digital sensors, some colors may alter throughout a set of photographs. Please note that certain colors do not reproduce exactly in print. Prints made at different times, in different sizes, or printed from different print labs may be variable in color balance.</span></p><p><br></p><p><span style="color: rgb(0, 0, 0);">Due to the limitations of computer monitors, it is understood that images may appear differently according to the specification of each monitor and prints will not necessarily match images rendered on any particular computer monitor.</span></p><p><br></p><p><span style="color: rgb(127, 127, 127);">GUARANTEED DELIVERY</span></p><p><br></p><p><span style="color: rgb(0, 0, 0);">The Photographer agrees to have the contracted order for the Client’s photographs completed within </span><span style="color: rgb(237, 123, 123);">10</span><span style="color: rgb(0, 0, 0);"> weeks from the day of the event/session.</span></p><p><br></p><p><span style="color: rgb(0, 0, 0);">The terms of this Contract are accepted by:</span></p>
`

export const dynamicContractInput = (length, disabled) => {
  if (!!disabled) {
    return `<input style='width: ${
      length * 10
    }px; height: 30px; font-size: 16px; padding-left: 4px; margin: 3px 0;' id='contract-input' disabled>`
  } else {
    return `<input style='width: ${
      length * 10
    }px; height: 30px; font-size: 16px; padding-left: 4px; margin: 3px 0;' id='contract-input'>`
  }
}

export const parseHtmlBody = (htmlBody, disableInputs = false) => {
  const dynamicInput = (length, disabled) => {
    if (!!disabled) {
      return `<input style='width: ${
        length * 10
      }px; height: 30px; font-size: 16px; padding-left: 4px; margin: 3px 0;' id='contract-input' disabled>`
    } else {
      return `<input style='width: ${
        length * 10
      }px; height: 30px; font-size: 16px; padding-left: 4px; margin: 3px 0;' id='contract-input'>`
    }
  }
  const dynamicTextarea = (length, rows, disabled) => {
    if (!!disabled) {
      return `<textarea rows='${rows}' style='width: ${
        length * 10
      }px; font-size: 16px; padding-left: 4px; margin: 3px 0; display: block;' id='contract-input' disabled>`
    } else {
      return `<textarea rows='${rows}' style='width: ${
        length * 10
      }px; font-size: 16px; padding-left: 4px; margin: 3px 0; display: block;' id='contract-input'>`
    }
  }

  const replaceWithInput = (body, disabled) => {
    let bodyCopy = body

    for (let i = 100; i >= 2; i -= 2) {
      const textareaRegex = new RegExp(`/[0-9]_{${i},}[0-9]/`, 'g')
      const inputRegex = new RegExp(`_{${i},}`, 'g')

      const matches = [...bodyCopy.matchAll(textareaRegex)]

      for (const match of matches) {
        const rows = +match[0][1]

        bodyCopy = bodyCopy.replace(match[0], `${dynamicTextarea(i, rows, disabled)}</textarea>`)
      }

      bodyCopy = bodyCopy.replace(inputRegex, `${dynamicInput(i, disabled)}</input>`)
    }

    return bodyCopy
  }

  return {
    parsedBody: replaceWithInput(htmlBody, disableInputs),
  }
}

export const STARTER_PLAN_NAME = 'Starter Plan'

///----color themes -----///
const localColorThemes = [
  {
    name: 'Default',
    text: '#1F1B17',
    background: '#F4F3F2',
    accent1: '#B88E73',
    accent2: '#DAD4CE',
    accent3: '#A49B95',
    footerTextColor: '#000000',
    navTextColor: '#ffffff',
    footerLogo: 0,
    navLogo: 1,
    submitButtonTextColor: '#1F1B17',
    bookWithMeButtonTextColor: '#1F1B17',
  },
  {
    name: 'Forest',
    text: '#1F1B17',
    background: '#E9E5E1',
    accent1: '#3A4531',
    accent2: '#A1A999',
    accent3: '#77856A',
    footerTextColor: '#000000',
    navTextColor: '#ffffff',
    footerLogo: 0,
    navLogo: 1,
    submitButtonTextColor: '#1F1B17',
    bookWithMeButtonTextColor: '#1F1B17',
  },
  {
    name: 'Earth',
    text: '#F9F5F3',
    background: '#382A27',
    accent1: '#9A8872',
    accent2: '#4A413C',
    accent3: '#868072',
    footerTextColor: '#000000',
    navTextColor: '#ffffff',
    footerLogo: 0,
    navLogo: 1,
    submitButtonTextColor: '#F9F5F3',
    bookWithMeButtonTextColor: '#F9F5F3',
  },
  {
    name: 'Fall',
    text: '#FCFCFB',
    background: '#485253',
    accent1: '#C88E63',
    accent2: '#7D837E',
    accent3: '#CF8145',
    footerTextColor: '#000000',
    navTextColor: '#ffffff',
    footerLogo: 0,
    navLogo: 1,
    submitButtonTextColor: '#FCFCFB',
    bookWithMeButtonTextColor: '#FCFCFB',
  },
  {
    name: 'Sweet',
    text: '#382E2A',
    background: '#F7EFEC',
    accent1: '#999B84',
    accent2: '#CD9E8F',
    accent3: '#999B84',
    footerTextColor: '#000000',
    navTextColor: '#ffffff',
    footerLogo: 0,
    navLogo: 1,
    submitButtonTextColor: '#382E2A',
    bookWithMeButtonTextColor: '#382E2A',
  },
  {
    name: 'Sunny',
    text: '#382E2A',
    background: '#FDF9EA',
    accent1: '#925818',
    accent2: '#ECDEBC',
    accent3: '#AB8024',
    footerTextColor: '#000000',
    navTextColor: '#ffffff',
    footerLogo: 0,
    navLogo: 1,
    submitButtonTextColor: '#382E2A',
    bookWithMeButtonTextColor: '#382E2A',
  },
  {
    name: 'Sand',
    text: '#1F1B17',
    background: '#F4F3F2',
    accent1: '#B88E73',
    accent2: '#DAD4CE',
    accent3: '#A49B95',
    footerTextColor: '#000000',
    navTextColor: '#ffffff',
    footerLogo: 0,
    navLogo: 1,
    submitButtonTextColor: '#1F1B17',
    bookWithMeButtonTextColor: '#1F1B17',
  },
]

export const getColorObj = (colorScheme) => {
  return localColorThemes.find((theme) => colorScheme === theme.name) || localColorThemes[0]
}

//----instagram App credential ---
// const CLIENT_ID = 800678131478966
// const CLIENT_SECRET = 'e3a4aa486d8977d5d5d1722ad257ef64'

// export const instagramApp = {
//   CLIENT_ID: 1112286809758150,
//   CALLBACK_URL: `${ADMIN_LINK_BASE() || `https://app.dev.bookfocal.com`}/admin/blog`,
//   CLIENT_SECRET: '7e6f0a8242b5f24b2fba38850a21eebd',
// }

//FOCAL-IG app - restore after successful test
export const instagramApp = {
  CLIENT_ID: 1111506373456063,
  CALLBACK_URL: `${ADMIN_LINK_BASE() || `https://app.dev.bookfocal.com`}/admin/blog`,
  CLIENT_SECRET: 'a9c2c40e03f7391eae1f2fd5afe26453',
}

//FOCAL_TEST_IG app
// export const instagramApp = {
//   CLIENT_ID: 1071619488097283,
//   CALLBACK_URL: `${ADMIN_LINK_BASE() || `https://app.dev.bookfocal.com`}/admin/blog`,
//   CLIENT_SECRET: '9b37e407cd05b1074b2ea867dce35833',
// }

export const weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
